var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMp4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000110454098937030471790000012577928216200374460_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MP4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "File"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m302.2 0h-191.1c-18.4 0-33.4 15-33.4 33.5v445.1c0 18.5 15 33.4 33.5 33.5h335.5c18.5 0 33.4-15 33.5-33.5l-1-330.6z",
    fill: "#d9defb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.2 0-.5 144.5s.5 3.5 3.5 3.5h174z",
    fill: "#3b478f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m45.5 246.7h337.6c7.5 0 13.6 6.1 13.6 13.6v150.8c0 7.5-6.1 13.6-13.6 13.6h-337.6c-7.5 0-13.6-6.1-13.6-13.6v-150.8c0-7.5 6.1-13.6 13.6-13.6z",
    fill: "#3b478f"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m97 299.1h30.4l11.7 45.6 11.7-45.6h30.4v74.9h-19v-57.1l-14.5 57.1h-17.2l-14.5-57.1v57.1h-19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.9 299.1h38.5c8.4 0 14.7 2 18.8 6 4.2 4 6.3 9.7 6.3 17 0 7.6-2.3 13.5-6.8 17.7-4.5 4.3-11.5 6.4-20.7 6.4h-12.7v27.8h-23.3v-74.9zm23.2 32h5.8c4.5 0 7.6-.8 9.4-2.3s2.8-3.7 2.7-6c.1-2.2-.8-4.4-2.4-6s-4.5-2.5-8.8-2.5h-6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304 360h-37.9v-17.1l37.9-45.1h18.1v46h9.4v16.2h-9.4v14h-18.1zm0-16.1v-23.6l-20 23.6z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp4);
export default __webpack_public_path__ + "static/media/mp4.50c97d65bd8492275ef8719dcc0f46c5.svg";
export { ForwardRef as ReactComponent };